export const emsFacilityFilter = {
  include: [
    {
      relation: 'entity',
    },
    {
      relation: 'facilityLocations',
      scope: {
        include: {
          relation: 'place',
        },
        where: {
          inactive: false,
        },
      },
    },
    {
      relation: 'emsFacilityDepartments',
      scope: {
        include: 'department',
      },
    },
  ],
};
